module.exports = __webpack_public_path__ + "static/media/ic_searchtype_anchorage.29e32b8e.svg";